import React, { useEffect } from 'react';
import { Container } from './styled';
import { PhishNetLogo } from '@ui/components';

const PHISHNET_INSTRUCTIONS_ROUTE = '/settings/email/phish-submissions/phishnet-o365';
const PHISHNET_INSTRUCTIONS_LABEL = 'Dashboard > Settings > Phish Submissions > PhishNet O365';

export const PortalInstructions = () => {
  const [dashboardUrl, setDashboardUrl] = React.useState(false);
  useEffect(() => {
    // @ts-ignore
    setDashboardUrl(globalThis.window ? window.API_ENDPOINT + PHISHNET_INSTRUCTIONS_ROUTE : false);
  }, []);
  return (
    <Container>
      <PhishNetLogo />
      <h1 suppressHydrationWarning>Cloudflare PhishNet™</h1>
      <i>O365 Phish Submission Button</i>
      <p>Please return to the dashboard and follow the instructions to provision this application.</p>
      {dashboardUrl && (
        <a href={dashboardUrl.toString()} className="js-only">
          {PHISHNET_INSTRUCTIONS_LABEL}
        </a>
      )}
      <noscript>
        <span>{PHISHNET_INSTRUCTIONS_LABEL}</span>
      </noscript>
    </Container>
  );
};
